import { matchPath, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PageFooter } from '@zillow/page-frame';
import { useSiftScience } from '@zg-rentals/sift-science';

import Routes from '../../utils/routes';
import './App.scss';
import useRedirectUrl from './hooks/useRedirectUrl';
import { TERMS, ZILLOW_TENANT_SCREENING_SERVICES } from '../../constants/paths';
import { Helmet } from 'react-helmet';
import { PAGE_TITLE } from '../../constants/stringConstants';
import ExternalRedirect from './components/ExternalRedirect';
import { ErrorBoundary } from '../../components/ErrorBoundary';
import AppLayoutContainer from './components/AppLayoutContainer';
import { useComscorePageTracking } from '@zg-rentals/comscore';
import { trackComscoreEvent } from '../../../client/analytics';

function App({ host, pathname, isInWebView, isLayoutHorizontal, userEmail, impersonatorUserToken }) {
  const location = useLocation();

  useSiftScience({ email: userEmail, isImpersonator: Boolean(impersonatorUserToken) });
  useComscorePageTracking(() => trackComscoreEvent({}), location.pathname);

  const redirectUrl = useRedirectUrl();
  const isTermsPage = matchPath(pathname, TERMS);
  const isZtssPage = matchPath(pathname, ZILLOW_TENANT_SCREENING_SERVICES);
  const showNav = !isInWebView && !isTermsPage;

  return (
    <>
      <div className="App__wrapper">
        <div style={{ display: 'none' }}>Credit score</div>
        <Helmet>
          <html lang="en" />
          <title>{PAGE_TITLE}</title>
        </Helmet>
        <AppLayoutContainer
          host={host}
          pathname={pathname}
          isLayoutHorizontal={isLayoutHorizontal && !isZtssPage}
          hideHeaderNavigation={!showNav}
        >
          <ErrorBoundary>
            <Routes />
          </ErrorBoundary>
          {showNav && <PageFooter />}
        </AppLayoutContainer>
      </div>
      {redirectUrl ? <ExternalRedirect to={redirectUrl} /> : null}
    </>
  );
}

App.propTypes = {
  host: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
  isInWebView: PropTypes.bool.isRequired,
  isLayoutHorizontal: PropTypes.bool.isRequired,
  userEmail: PropTypes.string,
  impersonatorUserToken: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    isInWebView: state.app.isInWebView,
    isLayoutHorizontal: state.app.isLayoutHorizontal,
    impersonatorUserToken: state.user.impersonatorUserToken,
    userEmail: state.user.email,
  };
}

export default connect(mapStateToProps, null)(App);
